import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Tooltip } from '@trevor/ui-components';
import { openReactModal } from '../actions/actions-react-modal';
import ModalContent from './ModalContent';
import css from '../css/module/chart-hints.css';
import { safeOnClick } from '../util/helpers/event-helpers';

class ModalTip extends Component {
  render() {
    const { title, onOpenTip, body, children, medium } = this.props;

    const modalContent = (
      <ModalContent small={!medium} medium={medium} header={title} autoHeight>
        <div className={`${css.container} ${css.modalTipContainer}`}>
          {body}
          <p style={{ marginTop: '15px' }}>
            Have a question?{' '}
            <span
              className="link"
              onClick={(e) => {
                e.preventDefault();
                Intercom('show');
              }}
            >
              Chat with us
            </span>
            .
          </p>
        </div>
      </ModalContent>
    );

    return children ? (
      <div
        className={css.cursorPointer}
        onClick={safeOnClick(() => onOpenTip(modalContent))}
      >
        {children}
      </div>
    ) : (
      <span>
        <span className={css.cursorPointer} data-tooltip-id={title}>
          <span
            style={{ fontSize: '0.8em', marginLeft: '3px', color: '#444' }}
            onClick={safeOnClick(() => onOpenTip(modalContent))}
          >
            <FontAwesomeIcon icon="question-circle" />
          </span>
        </span>
        <Tooltip id={title}>
          <span>Learn more</span>
        </Tooltip>
      </span>
    );
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    onOpenTip: (content) => {
      dispatch(openReactModal(content));
    },
  };
};

export default connect(null, mapDispatchToProps)(ModalTip);
